import React from 'react';
import { Line, Path } from 'react-konva';

const DefaultFlagIcon = (props) => {
	const theme = props?.theme ?? 'light';
	const size_portion = props?.size_portion ?? 25;
	const path_scale = props?.path_scale ?? 1;
	const x = props?.x ?? 0;
	const y = props?.y ?? 0;
	const init_x = props?.init_x ?? 0;
	const init_y = props?.init_y ?? 0;

	return (
		<>
			<Path
				fill="gray"
				data="M14.76,20.98c0,0.29-1.96,0.52-4.38,0.52S6,21.27,6,20.98c0-0.27,1.79-0.5,4.05-0.51c0.11,0,0.22,0,0.33,0C12.8,20.47,14.76,20.7,14.76,20.98z"
				width={size_portion}
				height={size_portion}
				pos_x={x}
				pos_y={y}
				x={init_x + size_portion * 0.06}
				y={init_y + size_portion * 0.06}
				scaleX={path_scale}
				scaleY={path_scale}
				stroke="gray"
				strokeWidth={0.5}
				lineCap="round"
				lineJoin="round"
			/>

			<Line
				points={[8.76, 3.5, 10.38, 20.98]}
				width={size_portion}
				height={size_portion}
				pos_x={x}
				pos_y={y}
				x={init_x + size_portion * 0.06}
				y={init_y + size_portion * 0.06}
				stroke={(theme == 'light') ? 'black' : 'white'}
				strokeWidth={1}
				scaleX={path_scale}
				scaleY={path_scale}
				lineCap="round"
				lineJoin="round"
			/>

			<Path
				fill="red"
				data="M8.85,4.53C9.9,5.38,10.61,6.6,10.74,8s-0.35,2.71-1.23,3.72L19,7.32L8.85,4.53z"
				width={size_portion}
				height={size_portion}
				pos_x={x}
				pos_y={y}
				x={init_x + size_portion * 0.06}
				y={init_y + size_portion * 0.06}
				scaleX={path_scale}
				scaleY={path_scale}
				stroke="red"
				strokeWidth={0.5}
				lineCap="round"
				lineJoin="round"
			/>
		</>
	)
}

export default DefaultFlagIcon;